<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12ZM15.999 11.2556C15.9965 11.3769 15.9616 11.4953 15.8981 11.5986L10.9994 19.5593V13.5593H8.6814C8.56011 13.5594 8.44099 13.5271 8.33635 13.4658C8.2317 13.4044 8.14532 13.3163 8.08614 13.2104C8.02695 13.1045 7.9971 12.9848 7.99966 12.8635C8.00223 12.7423 8.03712 12.6239 8.10074 12.5206L12.9994 4.55927V10.5593H15.3174C15.4387 10.5593 15.5578 10.5917 15.6624 10.6531C15.767 10.7145 15.8534 10.8027 15.9126 10.9086C15.9717 11.0145 16.0016 11.1343 15.999 11.2556Z"
      fill="currentColor"
    />
  </svg>
</template>
